import React from 'react';
import { redirectTo, detailUrlWithQueries } from 'src/utils/Http';
import { ArrowDoubleNext, ArrowDoublePrev } from 'jbc-front/components/icons';
import styles from './NextAndPrevRecordButton.scss';

const showEmployee = employee => {
  if (!employee) {
    return '';
  }
  return employee.fullName;
};

const NextAndPrevRecordButton = ({ nextInfo, prevInfo, urlFormat }) => {
  const { nextId, nextEmployee, nextQueries } = nextInfo || {};
  const { prevId, prevEmployee, prevQueries } = prevInfo || {};
  const nextRecordUrl = detailUrlWithQueries(nextId, nextQueries, urlFormat);
  const prevRecordUrl = detailUrlWithQueries(prevId, prevQueries, urlFormat);

  return (
    <div className={styles.wrap}>
      {prevRecordUrl && (
        <div className={styles.prev} onClick={() => redirectTo(prevRecordUrl)} role="button" tabIndex="0">
          <ArrowDoublePrev size={15} />
          {showEmployee(prevEmployee)}
        </div>
      )}
      {prevRecordUrl && nextRecordUrl && <div className={styles.bar}>｜</div>}
      {nextRecordUrl && (
        <div className={styles.next} onClick={() => redirectTo(nextRecordUrl)} role="button" tabIndex="0">
          {showEmployee(nextEmployee)}
          <ArrowDoubleNext size={15} />
        </div>
      )}
    </div>
  );
};

export default NextAndPrevRecordButton;
